import {
  AssignModel,
  createClient,
  IdPathParameters,
  OwnerResponse,
  postRequestFactory,
  SaveOperation,
  SearchOperation,
  searchRequestFactory
} from '@infuse/api/common';

const client = createClient('/rest/operator-api/charging-stations');

export const chargingStationAccessManagementPermissions = {
  ASSIGN: 'cpms.assign-charging-station',
  UNASSIGN: 'cpms.unassign-charging-station',
  SEARCH_OWNERS: 'cpms.search-charging-station-owners'
};

export type AssignChargingStationRequest = AssignModel;
export type UnassignChargingStationRequest = AssignModel;

export const assignChargingStation: SaveOperation<AssignChargingStationRequest, void, string> = postRequestFactory<
  AssignChargingStationRequest,
  void
>(client, {
  pattern: '/{id}/assign',
  permissionId: chargingStationAccessManagementPermissions.ASSIGN
});

export const unassignChargingStation: SaveOperation<UnassignChargingStationRequest, void, string> = postRequestFactory<
  UnassignChargingStationRequest,
  void
>(client, {
  pattern: '/{id}/unassign',
  permissionId: chargingStationAccessManagementPermissions.UNASSIGN
});

export const getChargingStationOwners: SearchOperation<OwnerResponse, IdPathParameters<string>> = searchRequestFactory<
  OwnerResponse,
  IdPathParameters<string>
>(client, {
  pattern: '/{id}/owners',
  permissionId: chargingStationAccessManagementPermissions.SEARCH_OWNERS
});
